import { render, staticRenderFns } from "./BountySubmissionCard.vue?vue&type=template&id=9fedf28a"
import script from "./BountySubmissionCard.vue?vue&type=script&lang=js"
export * from "./BountySubmissionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports